import {
    Card, CardHeader, CardContent, Box, Chip, FormControl, FormHelperText, IconButton, MenuItem, Select, SelectChangeEvent, Typography,
    Button, TableCell, Unstable_Grid2 as Grid, TextField, Checkbox, ListItemText, FormControlLabel, InputLabel, ToggleButton, ToggleButtonGroup, Avatar, Tooltip, Paper
} from "@mui/material";
import { Add } from '@mui/icons-material';
import { DataField, DropdownModel, FilterAttribute, FormDataOutput, TimeRestriction, TimeRestrictionsOutput } from "../../data/interfaces/sharedmodels";
import { useAppSelector, useAppDispatch } from "../../stores/hooks";
import {
    updateFilterAtts as updateMagneticFilterAtts
} from "../../stores/magneticslice";
import { useCallback, useContext, useEffect, useState } from "react";
import magneticService from "../../data/api/magnetic.service";
import { showerrormessage, showsuccessmessage, showwarningmessage } from "../../stores/notificationslice";
import ConfirmDialog from "../confirmdialog";
import dayjs, { Dayjs } from "dayjs";
import { LocalizationProvider, TimePicker, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import MasterListDialog from "../../modules/masterlist/childcomponents/masterlistdialog";
import DataTableHeader from "../childcomponents/datatableheader";
import { formatValue } from "../commonfunctions";
import _ from "lodash";
import { IsEditedContext } from "../../../App";

const formatDateValueForApi = (value: Dayjs,callbackFornull:any,id:number,istart:boolean) => {
        if(!value){
            callbackFornull(id,istart);
            return;
        }
        let startHour = dayjs().startOf('day');
        return value.diff(startHour, 'minute', false);
}




const SelectedDays = ({ data, handleRestrictionDaysChange }: { data: TimeRestrictionsOutput, handleRestrictionDaysChange: any }) => {
    const datatbleexpanded = useAppSelector((state) => state.magneticReducer.datatableExpanded);
    return (
        <Box >
            {data.TypeLookUps.findIndex(a => a.FieldName == "DayType") > -1 ? data.TypeLookUps.filter(a => a.FieldName == "DayType")[0].LookUpValues.map((daytype) => {

                let currentValue = data.RestrictionDays.findIndex(a => a.RestrictionId == data.RestrictionId && a.DayTypeId.toString() == daytype.Id) > -1;
                return (

                    <FormControlLabel key={daytype.Id} control={<Checkbox disabled={!data.IsEditable} sx={{cursor:data.IsEditable?"pointer":"not-allowed"}} size="small" checked={currentValue} value={formatValue(currentValue, "checkbox")} onChange={(event) => handleRestrictionDaysChange(data.RestrictionId, daytype.Id, event.target.checked)} />} label={daytype.Description} />

                )
            })

                : null}
        </Box>
    )
}

const SelectedSets = ({ data, handleTravelSetsChange }: { data: TimeRestrictionsOutput, handleTravelSetsChange: any }) => {

    return (
        <Box component={Paper} sx={{ p: 2 }}>
           
            <Typography variant="h6" sx={{ mb: 2 }}>Travel Sets</Typography>
            {data&&data.TravelSets?
            <Grid container spacing={1}>
                {data.TravelSets.map((travelset,index) => {

                    return (
                        <Grid key={'travelset_'+(travelset.Id==0?index:travelset.Id)} xs={12 / 16} sx={{ mb: 1, minWidth: 60 }}>
                            <TextField disabled={!data.IsEditable} InputProps={{ inputProps: { min: 0, max: 4 } }} label={travelset.Group} size="small" sx={{ width: '100%' }} onChange={(event)=>handleTravelSetsChange(travelset.Group,event.target.value)} value={formatValue(travelset.Set, "number")} type="number" />
                        </Grid>
                    )
                })

                }
            </Grid>:null}
        </Box>
    )
}

const TimeRestrictionEntries = ({ data, parent, handleTimeRestrictionChange, handleRestrictionDaysChange,handleSelectedRestriction }:
    { data: TimeRestrictionsOutput, parent: string, handleTimeRestrictionChange: any, handleRestrictionDaysChange: any,handleSelectedRestriction:any}) => {
    const dispatch = useAppDispatch();
    const [currentData, setCurrentData] = useState<TimeRestrictionsOutput>(data);
    
    const [newRestriction, setNewRestriction] = useState<string>('');
    const [currentNewId, setCurrentNewId] = useState(-99);
    const datatbleexpanded = useAppSelector((state) => state.magneticReducer.datatableExpanded);
 
    useEffect(() => {
        setCurrentData(data);

    }, [data]);

    const onRestrictionChange = (event: any) => {
        handleSelectedRestriction(event.target.value);
    }

    const addRestriction = () => {
        let restrictionNames = currentData.TypeLookUps.filter(a => a.FieldName == "RestrictionId")[0];
        if (restrictionNames) {
            if (restrictionNames.LookUpValues.length >= 12) {
                dispatch(showwarningmessage("A maximum of 12 restrictions can be defined for a station."));
            } else {
                restrictionNames.LookUpValues.push({ Id: currentNewId.toString(), Description: newRestriction });
                currentData.RestrictionId = currentNewId;
                setCurrentNewId(currentNewId + 1);
                setNewRestriction('');
            }
        }
    }

    const removeRestriction = () => {
        
        if (currentData.RestrictionId) {
            let tempdata={...currentData};
            let restrictionNames = tempdata.TypeLookUps.filter(a => a.FieldName == "RestrictionId")[0];
            restrictionNames.LookUpValues.splice(restrictionNames.LookUpValues.findIndex(a=>a.Id==currentData.RestrictionId.toString()),1);
                tempdata.TypeLookUps.filter(a => a.FieldName == "RestrictionId")[0].LookUpValues=restrictionNames.LookUpValues;
                tempdata.RestrictionDays=tempdata.RestrictionDays.filter(a=>a.RestrictionId!=currentData.RestrictionId);
                tempdata.TimeRestrictions=tempdata.TimeRestrictions.filter(a=>a.RestrictionId!=currentData.RestrictionId);
                restrictionNames = currentData.TypeLookUps.filter(a => a.FieldName == "RestrictionId")[0];
                tempdata.RestrictionId=restrictionNames.LookUpValues.length?parseInt(tempdata.TypeLookUps.filter(a => a.FieldName == "RestrictionId")[0].LookUpValues[0].Id):0;
                setCurrentData(tempdata);
            
        }
    }

    const removeTimeRestriction = (Id:number,isStart:boolean) => {
        if (Id) {
                let tempdata={...currentData};
                let restriction=tempdata.TimeRestrictions.filter(a=>a.Id==Id);
                if(!restriction.length)return;
                if(isStart){
                    if(restriction[0].EndTime==null)
                        tempdata.TimeRestrictions.splice(tempdata.TimeRestrictions.findIndex(a=>a.Id==Id),1);
                    else
                    restriction[0].StartTime=null;
                }
                else{
                    if(restriction[0].StartTime==null)
                        tempdata.TimeRestrictions.splice(tempdata.TimeRestrictions.findIndex(a=>a.Id==Id),1);
                    else
                        restriction[0].EndTime=null;
                }
                
                setCurrentData(tempdata);
            
        }
    }





    return (
        <Box component={Paper} sx={{ p: 2 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>Time Restrictions</Typography>
            {currentData.TypeLookUps&& currentData.TypeLookUps.length ?
                <Box sx={{ display: 'flex' }}>
                    <FormControl  >
                        <InputLabel>Select Restriction</InputLabel>
                        <Select
                            size="small"
                            label="Select Restriction"
                            sx={{ mb: 2, minWidth: 200 }}
                            value={currentData.RestrictionId}
                            onChange={onRestrictionChange}
                        >

                            {
                                currentData.TypeLookUps.filter(a => a.FieldName == "RestrictionId")[0].LookUpValues.map((item) => {
                                    return (
                                        <MenuItem key={item.Id} value={item.Id}>{item.Description}</MenuItem>
                                    )
                                })}


                        </Select>
                    </FormControl>
                    <FormControl sx={{ ml: 2 }}>
                        <TextField sx={{ minWidth: 200 }} disabled={!data.IsEditable} size="small" label="Enter Restriction" value={newRestriction} onChange={(event) => setNewRestriction(event.target.value)} />
                    </FormControl>
                    <FormControl>
                        <Button sx={{ ml: 2, marginTop: '4px' }} onClick={addRestriction} disabled={newRestriction == ''||!data.IsEditable} variant="outlined" size="small">Add</Button>
                    </FormControl>
                    <FormControl>
                        <Button sx={{ ml: 2, marginTop: '4px' }} onClick={removeRestriction} disabled={currentData.RestrictionId<1||!data.IsEditable} variant="outlined" size="small">Delete</Button>
                    </FormControl>

                </Box> : null}
            {currentData.RestrictionId ?
                <Grid container spacing={2} >
                    <Grid xs={datatbleexpanded ? 10.5 : 12}>
                        <Box>
                            {[1, 2, 3, 4].map((entry, index) => {
                                return (
                                    <Grid container spacing={1} key={'entry_' + index}>
                                        {[0, 1, 2, 3, 4].map((set, index2) => {
                                            return (
                                                <Grid xs={12 / 5} key={'entry_' + index + '_set_' + index2}>
                                                    {entry == 1 ? <Typography sx={{ textAlign: 'center', mb: 2, textTransform: 'uppercase' }}>{set == 0 ? 'Default Set' : 'Set ' + set}</Typography> : null}
                                                    {entry == 1 ? <Box sx={{ display: 'flex', justifyContent: 'space-evenly' }}><Typography sx={{ mb: 2 }}>Start Time</Typography><Typography sx={{ mb: 2, ml: 1 }}>End Time</Typography></Box> : null}
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                        <FormControl >
                                                            <div className="datepickerclass2">
                                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                    <TimePicker disabled={!data.IsEditable} ampm={false} sx={{ width: '100%' }} disableOpenPicker={!datatbleexpanded} onChange={(value) => handleTimeRestrictionChange(currentData.RestrictionId, entry, set, true, formatDateValueForApi(value,removeTimeRestriction,currentData.TimeRestrictions.findIndex(a => a.RestrictionId == currentData.RestrictionId && a.Entry == entry && a.Set == set)>-1?currentData.TimeRestrictions.filter(a => a.RestrictionId == currentData.RestrictionId && a.Entry == entry && a.Set == set)[0].Id:0,true))}
                                                                        value={currentData.TimeRestrictions.findIndex(a => a.RestrictionId == currentData.RestrictionId && a.Entry == entry && a.Set == set) > -1 ? formatValue(currentData.TimeRestrictions.filter(a => a.RestrictionId == currentData.RestrictionId && a.Entry == entry && a.Set == set)[0].StartTime, "Time", "Time24") : null} />
                                                                </LocalizationProvider>
                                                            </div>
                                                        </FormControl>
                                                        <FormControl sx={{ ml: 1 }}>
                                                            <div className="datepickerclass2">
                                                                <LocalizationProvider  dateAdapter={AdapterDayjs}>
                                                                    <TimePicker disabled={!data.IsEditable} ampm={false} sx={{ width: '100%' }} disableOpenPicker={!datatbleexpanded} onChange={(value) => handleTimeRestrictionChange(currentData.RestrictionId, entry, set, false, formatDateValueForApi(value,removeTimeRestriction,currentData.TimeRestrictions.findIndex(a => a.RestrictionId == currentData.RestrictionId && a.Entry == entry && a.Set == set)>-1?currentData.TimeRestrictions.filter(a => a.RestrictionId == currentData.RestrictionId && a.Entry == entry && a.Set == set)[0].Id:0,false))}
                                                                        value={currentData.TimeRestrictions.findIndex(a => a.RestrictionId == currentData.RestrictionId && a.Entry == entry && a.Set == set) > -1 ? formatValue(currentData.TimeRestrictions.filter(a => a.RestrictionId == currentData.RestrictionId && a.Entry == entry && a.Set == set)[0].EndTime, "Time", "Time24") : null} />
                                                                </LocalizationProvider>
                                                            </div>
                                                        </FormControl>
                                                    </Box>
                                                </Grid>
                                            )
                                        })}
                                    </Grid>
                                )
                            })}
                        </Box>
                    </Grid>
                    <Grid xs={datatbleexpanded ? 1.5 : 12}  >
                        <SelectedDays data={currentData} handleRestrictionDaysChange={handleRestrictionDaysChange}  />
                    </Grid>

                </Grid> : null}
            

        </Box>
    )
}

export default function TimeRestrictions({ heading, data, parent, versions, callback }:
    { heading: string | undefined, data: TimeRestrictionsOutput, parent: string, versions: DropdownModel[], callback: any }) {
        const dispatch = useAppDispatch();
        const [currentData, setCurrentData] = useState<TimeRestrictionsOutput>(data);
    const [dialogOpen, setDialogOpen] = useState<boolean>(false);
    const [dialogTitle, setDialogTitle] = useState<string>('');
    const [dialogMessage, setDialogMessage] = useState<string>('');
    const { setIsEdited } = useContext(IsEditedContext) ;
    const selectedTable = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.selectedDataTable; }
        else { return state.itsoReducer.selectedDataTable; }
    });
    const selectedVersion = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.selectedVersion; }
        else { return state.itsoReducer.selectedVersion; }
    });
    const selectedNlcs = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.selectedNlcs; }
        else { return state.itsoReducer.selectedNlcs; }
    });

    const [originalData, setOriginalData] = useState<TimeRestrictionsOutput>(_.cloneDeep(data));
    useEffect(() => {
        setOriginalData(_.cloneDeep(data));
        setCurrentData(data);

    }, [data]);
    const handleSelectedRestriction=useCallback((restrictionId:number)=>{
        let newData = { ...currentData };
        newData.RestrictionId=restrictionId;
        setCurrentData(newData);
        setIsEdited(true);
    },[currentData])
    const handleTimeRestrictionChange = useCallback((restrictionId: number, entry: number, set: number, isStart: boolean, value: number) => {
        
        let newData = { ...currentData };
        if (newData.TimeRestrictions.findIndex(a => a.RestrictionId == restrictionId && a.Entry == entry && a.Set == set) > -1) {
            if (isStart)
                newData.TimeRestrictions.filter(a => a.RestrictionId == restrictionId && a.Entry == entry && a.Set == set)[0].StartTime = value;
            else
                newData.TimeRestrictions.filter(a => a.RestrictionId == restrictionId && a.Entry == entry && a.Set == set)[0].EndTime = value;
        }
        else if(value!=null){
            newData.TimeRestrictions.push({Id:0, RestrictionId: restrictionId, Entry: entry, Set: set, StartTime: isStart ? value : 0, EndTime: isStart ? 0 : value });
        }
        console.log(newData);
        setCurrentData(newData);
        setIsEdited(true);
    }, [currentData]);

    const handleRestrictionDaysChange = useCallback((restrictionId: number, dayType: number, add: boolean) => {
        let newData = { ...currentData };
        if (add) {
            newData.RestrictionDays.push({ RestrictionId: restrictionId, DayTypeId: dayType });
        }
        else {
            newData.RestrictionDays.splice(newData.RestrictionDays.findIndex(a => a.RestrictionId == restrictionId && a.DayTypeId == dayType), 1);
        }
        setCurrentData(newData);
        setIsEdited(true);
    }, [currentData]);

    const handleTravelSetsChange = useCallback((group: number, set: number) => {
        let newData = { ...currentData };
        newData.TravelSets.filter(a => a.Group == group)[0].Set = set;
        console.log(newData);
        setCurrentData(newData);
        setIsEdited(true);
    }, [currentData]);

    const handleSaveClick = () => {
        //let modifiedData = { ...currentData }
        let modifiedData = _.cloneDeep(currentData);

        if (_.isEqual(modifiedData, originalData)) {
            dispatch(showerrormessage("There is No data has changed.."));
            return;
        }


        modifiedData.Version = selectedVersion ?? "";
        const updateInput = { NlcId: selectedNlcs.length > 0 ? selectedNlcs[0].Id : 0, TocId: 1, InputData: modifiedData };
        magneticService.updateTimeRestrictionFormData(updateInput).then((response) => {
            if (response && response.data) {
                dispatch(showsuccessmessage("The data is saved successfully."))
                setIsEdited(false);
                callback();
            }
            else{
               
                return;
            }
        });

    }

    const handleSetCurrent = () => {
        setDialogTitle('Set Version');
        setDialogMessage('Confirm change of current version to as ' + selectedVersion + '?');

        setDialogOpen(true);
    }

    const setCurrentVersion = useCallback((confirmed: boolean, remarks: string) => {
        setDialogOpen(false);
        if (confirmed) {
            magneticService.setCurrentVersion(selectedVersion ?? "", selectedTable?.Id ?? 0, remarks,selectedNlcs[0].Id).then((response) => {
                if (response.data.IsSuccess) {
                    dispatch(showsuccessmessage(response.data.Message));
                    callback();
                }
                else {
                    dispatch(showerrormessage(response.data.Message))
                }

            });
        }
    }, [selectedTable, selectedVersion]);

    return (
        <Card>
            <CardHeader title={<DataTableHeader heading={heading} parent={parent} versions={versions} />} />
            <CardContent>
                {heading == undefined ? '' :
                    currentData.TravelSets && currentData.TravelSets.length ?
                        <Grid container spacing={2}>
                            <Grid xs={12}>
                                <TimeRestrictionEntries data={currentData} parent={parent} handleTimeRestrictionChange={handleTimeRestrictionChange} handleRestrictionDaysChange={handleRestrictionDaysChange} handleSelectedRestriction={handleSelectedRestriction}/>
                            </Grid>
                            <Grid xs={12}>
                                <SelectedSets data={currentData} handleTravelSetsChange={handleTravelSetsChange}  />
                            </Grid>
                            <Grid xs={12}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', m: 2 }}>
                                    
                                    {!currentData.ReadOnlyUser&&currentData.Version != selectedVersion ? <Button variant="outlined"  onClick={handleSetCurrent}>Set Current Version</Button> : <div></div>}
                                    {currentData.IsEditable?<Button variant="contained"  onClick={handleSaveClick}>Save</Button>:null}
                                </Box>
                            </Grid>
                        </Grid>
                        : <Typography sx={{ m: 2 }} variant="h6">No data found for the current selection.</Typography>
                }
            </CardContent>
            <ConfirmDialog isopen={dialogOpen} title={dialogTitle} message={dialogMessage} callback={setCurrentVersion} needComments={true} />
        </Card>
    );
}